import React from 'react';
import PropTypes from 'prop-types';
import TaskCard from './TaskCard';

/**
 * TaskList component - Renders a list of tasks using TaskCard components
 */
const TaskList = ({ tasks, onTaskClick, onTaskDelete, emptyMessage }) => {
  // Empty state
  if (tasks.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-lg p-12 text-center">
        <div className="max-w-md mx-auto">
          <div className="text-gray-400 mb-4">
            <svg className="w-24 h-24 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">
            {emptyMessage || 'No tasks found'}
          </h3>
          <p className="text-gray-600">
            {emptyMessage ? '' : 'Create a new task or adjust your filters to see tasks.'}
          </p>
        </div>
      </div>
    );
  }

  // Task list
  return (
    <div className="space-y-2">
      {tasks.map((task) => (
        <TaskCard
          key={task.id}
          task={task}
          onTaskClick={onTaskClick}
          onDelete={onTaskDelete}
        />
      ))}
    </div>
  );
};

TaskList.propTypes = {
  tasks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    priority: PropTypes.string.isRequired,
  })).isRequired,
  onTaskClick: PropTypes.func.isRequired,
  onTaskDelete: PropTypes.func,
  emptyMessage: PropTypes.string,
};

export default TaskList;
